import { IonIcon } from "@ionic/react";
import { chatbubbleOutline, chevronDownOutline, chevronUpOutline } from "ionicons/icons";
import { useState } from "react";
import { TrainerComment } from "../../models/reportModels";
import { format } from "date-fns";
import { de } from "date-fns/locale";

import "./TrainerCommentBubble.scss";

interface TrainerCommentBubbleProps {
  comments: TrainerComment[];
  className?: string;
}

const TrainerCommentBubble: React.FC<TrainerCommentBubbleProps> = ({
  comments,
  className = "",
}) => {
  const [expanded, setExpanded] = useState(false);

  if (!comments?.length) return null;

  return (
    <div
      className={`trainerCommentBubble ${className}`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      role="presentation"
    >
      <button
        type="button"
        className="trainerCommentBubble__trigger"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setExpanded((prev) => !prev);
        }}
        aria-expanded={expanded}
      >
        <IonIcon icon={chatbubbleOutline} />
        <span>
          {comments.length === 1
            ? "Kommentar vom Ausbilder"
            : `${comments.length} Kommentare vom Ausbilder`}
        </span>
        <IonIcon icon={expanded ? chevronUpOutline : chevronDownOutline} />
      </button>
      {expanded && (
        <div className="trainerCommentBubble__content">
          {comments.map((c) => (
            <div key={c.id} className="trainerCommentBubble__item">
              <p className="trainerCommentBubble__text">{c.comment}</p>
              <span className="trainerCommentBubble__meta">
                {format(new Date(c.created_at), "dd.MM.yyyy, HH:mm", { locale: de })}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TrainerCommentBubble;
